export const baseUrl='https://api.themoviedb.org/3'
export const API_KEY='5f6f334d30e8d1d3ed12b35ba787d10a'
export const imageUrl ='https://image.tmdb.org/t/p/original'
